export default __webpack_public_path__ + "static/media/sh2_2.68319520.jpg";